<template>
  <div class="card-body">
    <div class="fs-6 fw-bold text-center text-primary mb-5 my-4">
      <!-- logo otomatis dari backend / fallback -->
      <img :src="preview" alt="Logo Klinik" height="100">
      <!-- AZZAHRA
      <sup class="bg-success rounded-pill text-white fw-normal px-2">Admin</sup>-->
      <div
        class="fs-2 mt-2 fw-normal text-dark"
      >Masuk ke dashboard Anda, kelola aktivitas, dan jadikan hari lebih produktif.</div>
    </div>
    <form @submit.prevent="onSubmit">
      <div class="mb-3">
        <label for="exampleInputEmail1" class="form-label">Alamat Email *</label>
        <input
          v-model="form.username"
          type="email"
          class="form-control"
          id="exampleInputEmail1"
          placeholder="Alamat Email..."
          autocomplete="off"
          required
        >
      </div>
      <div class="mb-4">
        <label for="exampleInputPassword1" class="form-label">Kata Sandi *</label>
        <input
          v-model="form.password"
          type="password"
          class="form-control"
          id="exampleInputPassword1"
          placeholder="Kata Sandi..."
          autocomplete="off"
          required
        >
      </div>
      <div class="d-flex align-items-center justify-content-between mb-4">
        <div class="form-check">
          <input
            class="form-check-input primary"
            type="checkbox"
            value
            id="flexCheckChecked"
            checked
          >
          <label class="form-check-label text-dark" for="flexCheckChecked">Ingat perangkat ini</label>
        </div>
        <router-link to="/forgot-password" class="text-primary fw-bold">Lupa Sandi ?</router-link>
      </div>
      <button type="submit" class="btn btn-primary w-100 py-8 fs-4 mb-4 rounded-2">Masuk</button>
    </form>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import config from '../config'

export default {
	metaInfo: {
		titleTemplate: 'Login'
	},
	data() {
		return {
			faviconUrl: require('@/assets/favicon.ico'), // default lokal
			logoUrl: require('@/assets/logo_dzikri.png'), // default lokal
			token: localStorage.getItem('token'),
			showPassword: false,
			form: {
				username: null,
				password: null
			},
			errors: null
		}
	},
	computed: {
		...mapGetters({
			conf: 'location/getConfig'
		}),
		preview: {
			// getter
			get() {
				let url = ''
				if (this.conf && this.conf.logo) {
					url = config('api.baseUrl') + 'storage/uploads/' + this.conf.logo
				} else {
					url = this.logoUrl
				}
				return url
			},
			set(value) {
				this.conf.logo = value
			}
		}
	},
	methods: {
		...mapActions('auth', ['login', 'logout']),

		onSubmit: function() {
			console.log('sd')
			this.login({
				useremail: this.form.username,
				userpass: this.form.password
			})
				.then((res) => {
					console.log(res)
					let toast = this.$toasted.show(`Login berhasil`, {
						theme: 'bubble',
						position: 'top-right',
						duration: 3000
					})
				})
				.catch((err) => {
					let toast = this.$toasted.show(`${err.response.data.msg}`, {
						theme: 'bubble',
						position: 'top-right',
						duration: 3000
					})
					console.log('vue===========', err.response.data)
				})
		},
		onLogout: function() {
			this.logout({})
				.then((res) => {
					console.log('res===========', res)
				})
				.catch((err) => {
					console.log('err===========', err)
				})
		},
		setFavicon(iconPath) {
			let link = document.querySelector("link[rel~='icon']")
			if (!link) {
				link = document.createElement('link')
				link.rel = 'icon'
				document.getElementsByTagName('head')[0].appendChild(link)
			}
			link.href = iconPath
		}
	},
	created() {
		this.setFavicon(this.faviconUrl)
		if (this.token) {
			this.$router.push('/')
		}
	}
}
</script>
